import { useQuery } from '@tanstack/react-query';
import { getChildStories } from '../api/stories';

export function useChildStories(learnerId) {
  return useQuery({
    queryKey: ['childStories', learnerId],
    queryFn: () => getChildStories(learnerId),
    enabled: !!learnerId,
    select: (data) => {
      const stories = Array.isArray(data) ? data : data?.stories || [];
      const daily_limit_used = Array.isArray(data) ? false : (data?.daily_limit_used ?? false);
      return { stories, daily_limit_used };
    },
  });
}
